// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"64":"chunk-common","105":"views-Dashboard"}[chunkId] || chunkId) + "." + {"64":"1346eed2","105":"fc333f81","187":"2cbd031b","595":"4136a14f"}[chunkId] + ".js";
};